import { getCLS, getFID, getLCP, getTTFB, getFCP } from 'web-vitals';
import { EventTracking, EventType } from '@app/tracking';
if (window.MEASURE_WEB_VITALS) {
    // Core vitals
    getCLS(metric => EventTracking.dispatch(EventType.WebVitalsMetric, metric));
    getFID(metric => EventTracking.dispatch(EventType.WebVitalsMetric, metric));
    getLCP(metric => EventTracking.dispatch(EventType.WebVitalsMetric, metric));
    // Other vitals
    getFCP(metric => EventTracking.dispatch(EventType.WebVitalsMetric, metric));
    getTTFB(metric => EventTracking.dispatch(EventType.WebVitalsMetric, metric));
}
